function throwIfUnknownField(store, fieldName) {
  if (!store.fields[fieldName]) {
    throw new Error(`Trying to write an unknown field: ${String(fieldName)}`);
  }
}
export {
  throwIfUnknownField
};
//# sourceMappingURL=throwIfUnknownField.js.map
